import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css';
import './bootstrap.css';
import './plyr.css';
import './style.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {Provider} from 'react-redux'
import { store } from './createStore';
import './i18n';
import 'react-toastify/dist/ReactToastify.css';
import "react-datepicker/dist/react-datepicker.css";


ReactDOM.render(
    <Provider store={store}>
            <App />
    </Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
